// extracted by mini-css-extract-plugin
export default {"saasAdminHeader":"saas_admin_header___saasAdminHeader___af8b7749","fixedWidth":"saas_admin_header___fixedWidth___f160a476"};